import { createSlice } from '@reduxjs/toolkit';

const waterMeterSlice = createSlice({
  name: 'waterMeter',
  initialState: {
    waterMeters: [],
    loading: false,
    error: null
  },
  reducers: {}
});

export default waterMeterSlice.reducer;